import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Icon, TooltipHost } from 'office-ui-fabric-react';
import { getRelId } from '../../../../../features/helpers/apiHelpers';
import {
  kleOptionsMapper,
  optionsMapperIsActive,
} from '../../../../../utilities/mapperFunctions';

const dropdownStyles = {
  root: { padding: '20px 0' },
  label: {
    fontSize: '14',
    fontWeight: '500',
    color: '#333333',
  },
};

const iconStyles = {
  root: {
    paddingLeft: '10px',
  },
};

const MetaDataDropdowns = ({
  subjectAreas,
  cityAreas,
  hearingTypes,
  kleHierarchies,
  updateHearingModelAttribute,
  updateHearingModelRelationship,
  hearingModel,
  hearingModelInCreatedStatus,
  setSelectedEsdhTemplateId,
  showErrors,
}) => {
  const { t: translator } = useTranslation();

  const onChangeHearingTypeCallback = (_, value) => {
    updateHearingModelRelationship('hearingType', value.key);
    updateHearingModelRelationship('kleHierarchy', null);
    updateHearingModelAttribute('esdhTitle', '');
    setSelectedEsdhTemplateId(null);
  };

  const onChangeSubjectAreaCallback = (_, value) =>
    updateHearingModelRelationship('subjectArea', value.key);
  const onChangeCityAreaCallback = (_, value) =>
    updateHearingModelRelationship('cityArea', value.key);
  const onChangeKleHierarchyCallback = (_, value) =>
    updateHearingModelRelationship('kleHierarchy', value.key);

  return (
    <div>
      <Dropdown
        placeholder={translator('global.noneSelected')}
        label={translator('hearingProperties.hearingType')}
        onChange={onChangeHearingTypeCallback}
        selectedKey={getRelId(hearingModel, 'hearingType')}
        options={
          hearingTypes && hearingTypes.map(optionsMapperIsActive(translator))
        }
        styles={dropdownStyles}
        disabled={!hearingModelInCreatedStatus}
        errorMessage={
          showErrors && !getRelId(hearingModel, 'hearingType')
            ? translator('global.requiredField')
            : null
        }
      />
      <Dropdown
        placeholder={translator('global.noneSelected')}
        label={translator('hearingProperties.subjectArea')}
        onChange={onChangeSubjectAreaCallback}
        selectedKey={getRelId(hearingModel, 'subjectArea')}
        options={
          subjectAreas && subjectAreas.map(optionsMapperIsActive(translator))
        }
        styles={dropdownStyles}
        errorMessage={
          showErrors && !getRelId(hearingModel, 'subjectArea')
            ? translator('global.requiredField')
            : null
        }
      />
      <Dropdown
        placeholder={translator('global.noneSelected')}
        label={translator('hearingProperties.cityArea')}
        onChange={onChangeCityAreaCallback}
        selectedKey={getRelId(hearingModel, 'cityArea')}
        options={cityAreas && cityAreas.map(optionsMapperIsActive(translator))}
        styles={dropdownStyles}
        errorMessage={
          showErrors && !getRelId(hearingModel, 'cityArea')
            ? translator('global.requiredField')
            : null
        }
      />
      <Dropdown
        placeholder={translator('global.noneSelected')}
        onChange={onChangeKleHierarchyCallback}
        selectedKey={getRelId(hearingModel, 'kleHierarchy')}
        options={kleHierarchies && kleHierarchies.map(kleOptionsMapper)}
        styles={dropdownStyles}
        label={
          <div className="create-hearing-title-with-icon">
            <span>{translator('hearingProperties.kleNumber')}</span>
            <TooltipHost
              content={translator('pages.createHearing.kleNumberTooltip')}
            >
              <Icon iconName="Info" styles={iconStyles} />
            </TooltipHost>
          </div>
        }
        disabled={
          !getRelId(hearingModel, 'hearingType') || !hearingModelInCreatedStatus
        }
        errorMessage={
          showErrors && !getRelId(hearingModel, 'kleHierarchy')
            ? translator('global.requiredField')
            : null
        }
      />
    </div>
  );
};

export { MetaDataDropdowns };
